import { Button, CopyIcon, Tooltip } from "@saleor/macaw-ui-next";
import React, { forwardRef, useState } from "react";

interface BulkDuplicateButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export const BulkDuplicateButton = forwardRef<HTMLButtonElement, BulkDuplicateButtonProps>(
  ({ onClick, children, disabled }, ref) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    return (
      <Tooltip open={isTooltipOpen}>
        <Tooltip.Trigger>
          <Button
            ref={ref}
            disabled={disabled}
            onMouseOver={() => {
              setIsTooltipOpen(true);
            }}
            onMouseLeave={() => {
              setIsTooltipOpen(false);
            }}
            onClick={onClick}
            icon={<CopyIcon />}
            variant="secondary"
            data-test-id="bulk-duplicate-button"
          />
        </Tooltip.Trigger>
        <Tooltip.Content side="bottom">
          <Tooltip.Arrow />
          {children}
        </Tooltip.Content>
      </Tooltip>
    );
  },
);

BulkDuplicateButton.displayName = "BulkDuplicateButton";